export default function LanguageSwitcher () {
  const languageSwitcherPopup = document.querySelector('.mt-language-switcher-popup')
  const languageSwitcherOpenTriggers = document.querySelectorAll('.open-language-switcher')
  const languageSwitcherCloseTriggers = document.querySelectorAll('.close-language-switcher')

  if (languageSwitcherPopup) {

    languageSwitcherOpenTriggers.length > 0 && languageSwitcherOpenTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        languageSwitcherPopup.classList.toggle('mt-language-switcher-popup--show')
      })
    })

    languageSwitcherCloseTriggers.length > 0 && languageSwitcherCloseTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        languageSwitcherPopup.classList.remove('mt-language-switcher-popup--show')
      })
    })

    const keydownHandler = (e) => {
      if (e.key === 'Escape') {
        languageSwitcherPopup.classList.remove('mt-language-switcher-popup--show')
      }
    }

    document.addEventListener('keydown', keydownHandler)
    window.addEventListener('unload', () => {
      document.removeEventListener('keydown', keydownHandler)
    })
  }
}